import * as React from 'react';
import Box from '@mui/material/Box';
import logo from '../../logo.png';

const Logo = () => {
  return (
    <React.Fragment>
      <Box sx={{display: {xs: 'none', sm: 'flex'}, justifyContent: 'center', alignItems: 'center'}}>
          <img src={logo} alt='logo-adoro' width={48} height={48}/>
      </Box>
      <Box sx={{display: {xs: 'flex', sm: 'none'}, justifyContent: 'center', alignItems: 'center'}}>
          <img src={logo} alt='logo-adoro' width={24} height={24}/>
      </Box>
    </React.Fragment>
  );
};

export default Logo;
